import type { ApiService, Logger } from "@packages/common";
import type { Offer, OffersApiResponseDTO } from "./dtos";

import { API, LOGGER } from "@packages/common";
import { CONFIG, type Config } from "@packages/config";
import { Inject, Injectable } from "@webmotors/ioc";

import { OFFERS_SERVICE } from "./offers.types";

@Injectable(OFFERS_SERVICE)
export class OffersService {
  private readonly logger: Logger;

  constructor(
    @Inject(LOGGER) loggerFactory: Logger,
    @Inject(API) private readonly apiService: ApiService,
    @Inject(CONFIG) private readonly config: Config,
  ) {
    this.logger = loggerFactory.create(OFFERS_SERVICE);
  }

  async get(): Promise<Offer[]> {
    try {
      const response = await this.apiService
        .cache(900)
        .get<unknown, OffersApiResponseDTO[]>(
          "/carfair",
          {
            type: "all",
          },
          {
            baseURL: this.config.apiURL,
          },
        );

      const offers: Offer[] = response?.map((offer) => {
        const { BannerDesktop, BannerMobile } = offer;
        return {
          id: offer?.Id ?? 0,
          name: offer?.Name ?? "",
          alt: offer?.Name ? `Banner ${offer.Name}` : "",
          url: offer?.URL ?? "",
          bannerDesktop: BannerDesktop
            ? `${this.config.hotDealImage}${BannerDesktop}`
            : "",
          bannerMobile: BannerMobile
            ? `${this.config.hotDealImage}${BannerMobile}`
            : "",
          modalidade: offer?.Modalidade ?? 0,
        };
      });

      return offers ?? [];
    } catch (error) {
      this.logger.error("[Get]  Error fetching offers: ", error);

      return [];
    }
  }
}
